import * as React from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { IconArrow, rem, Spacer } from 'design-system';
import IconEmmaWallet from 'design-system/icons/IconEmmaWallet';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import useStyles from 'hooks/useStyles';
const ComingSoonTradingAccountCard = ({ image, title, onPress, subTitle, isComingSoon, }) => {
    const styles = useStyles(styleSet);
    return (<TouchableBounceCard noMarginBottom onDark disabled={!onPress || isComingSoon} onPress={onPress}>
      <View style={styles.headerContainer}>
        <View style={isComingSoon ? styles.translucentView : undefined}>
          <IconEmmaWallet size={rem(44)}/>
        </View>
        <Spacer w={16}/>
        <View style={styles.flex}>
          {!!isComingSoon && (<Text Text-14 Primary>
              COMING SOON
            </Text>)}
          <View style={isComingSoon ? styles.translucentView : undefined}>
            <Text Text-16>{title}</Text>
            <Text TextThin-14 Secondary>
              {subTitle}
            </Text>
          </View>
          {image ? (<>
              <Spacer h={4}/>
              {image}
            </>) : null}
        </View>
        {!isComingSoon && (<>
            <Spacer w={16}/>
            <IconArrow direction="right"/>
          </>)}
      </View>
    </TouchableBounceCard>);
};
export default ComingSoonTradingAccountCard;
const styleSet = createStyleSheets(() => ({
    headerContainer: {
        padding: rem(16),
        alignItems: 'center',
        flexDirection: 'row',
    },
    translucentView: {
        opacity: 0.5,
    },
    flex: {
        flex: 1,
    },
}));
